import api from "../api-backend";
//import store from '@/store';

class HeaderService {

    getHeaderInfo = async () => {

        const response = await api.get(`/engine/header`)
        let jsonData = JSON.parse(JSON.stringify(response.data.facet_counts.facet_queries).split("tipus:").join('').replace(':\\"Open Access\\"', "").replace("activitat_comunitat:", "").replace("activitat_comunitat:", "").replace(":assignaturesImpartidas", ""));
        //alert(JSON.stringify(jsonData))
        return {
            'num_professor': jsonData["professor AND professor_num_activitats:[1 TO *]"].toLocaleString(),
            'num_organitzacio': jsonData.organitzacio.toLocaleString(),
            'num_assignatura': jsonData.assignatura.toLocaleString(),
            'num_titulacio': jsonData.titulacio.toLocaleString(),
            'num_material': jsonData.material,
            'num_innovacio': jsonData.activitat_subinnovacio,
            'num_activitat': jsonData.activitat,
            'num_openAccess': jsonData.activitat_rights.toLocaleString(),
            'num_docencia': jsonData.activitat_subtipus_docencia.toLocaleString(),
            'num_pfc': jsonData.pfc.toLocaleString(),
            'num_video': jsonData.videodocent.toLocaleString(),
        }
    }



}

export default new HeaderService()
